import { V3dTools } from '@/v3d/common';
import { iApp } from '@/Interfaces/app';
import { Camera } from './camera';
// import { loader } from '@/Engine/loader';
import { IV3D } from '@/Interfaces/v3d';
// import {
//     eventLimitClearTime, version,
// } from '@/Constants/common';
import {
    axesHelperEnabled,
    gridDivisions,
    gridEnabled,
    gridSize,
} from '@/Constants/3dConfig';

import { $ } from '@/Engine/state';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { onStoreUpdateHandler } from '@/Engine/eventHandlers/onStoreUpdate';
import { onMouseDownHandler } from '@/Engine/eventHandlers/onMouseDownHandler';
import { onPointerUpHandler } from '@/Engine/eventHandlers/onMouseUpHandler';
import { onDeleteHandler } from '@/Engine/eventHandlers/onDeleteHandler';
import { onEscapeHandler } from '@/Engine/eventHandlers/onEscapeHandler';
import { onPointerMoveHandler } from '@/Engine/eventHandlers/onPointerMoveHandler';
import { onOrbitControlChangeHandler } from '@/Engine/eventHandlers/onOrbitControlChangeHandler';
import { updateUrlOnStoreChange } from '@/libs/updateUrlOnStoreChange';
import { Group, Object3D } from 'three';
import { iStoreCaseConfiguration } from '@/Interfaces/storeCaseConfiguration';
import { ARButton } from 'three/examples/jsm/webxr/ARButton';
import { ModelCache } from '@/Engine/modelCache';


declare let v3d: IV3D;

export const app = async function(app: iApp) {
    $.app = app;
    $.gltfLoader = new v3d.GLTFLoader();
    $.sceneBackGround = app.scene.background;
    app.hideFPS();
    // app.showFPS();
    app.disableRendering(0);
    $.container = document.getElementById('v3d-container') as HTMLElement;
    const render = (cb?: () => void) => requestAnimationFrame(() => {
        if ($.pauseRender) return;
        app.render();
        if (cb) cb();
    });

    const isRendering = false;
    const continueRender = () => {
        // TODO переделать
        // TODO по идее если isRendering, то мы должны обнулить интервал.
        // if (isRendering) return;
        app.enableRendering();
        if (!app.renderer.xr.isPresenting)
            app.disableRendering(35);
    };
    $.modelCache = new ModelCache();
    $.continueRender = continueRender;
    $.render = render;
    const v3dTools = new V3dTools(app);
    $.v3dTools = v3dTools;

    const camera = new Camera(app.getCamera(), v3dTools, app);
    $.camera = camera;
    app.controls.targetObj.position.set(1,1.5,0);


    offVisibleScene();
    if (gridEnabled)
        app.scene.add(new v3d.GridHelper(gridSize, gridDivisions));
    if (axesHelperEnabled)
        app.scene.add(new v3d.AxesHelper(1));

    // Subscriptions

    document.addEventListener('pointerdown', onMouseDownHandler);
    document.addEventListener('pointerup', onPointerUpHandler);
    document.addEventListener('pointermove', onPointerMoveHandler);

    document.addEventListener('keyup', (e)=>{
        if (e.key === 'Escape') {
            onEscapeHandler();
        }

        if (e.key === 'Backspace' || e.key === 'Delete') {
            onDeleteHandler();
        }
    });


    app.controls.addEventListener('change', ()=> {
        onOrbitControlChangeHandler();
    });

    useStoreCaseConfiguration().$subscribe((mutation, state) => {
        storeConfigurationUpdate(state);
    });

    window.addEventListener('resize', ()=>{
        $.render();
    });


    $.ARButton = ARButton.createButton(app.renderer, { requiredFeatures: [ 'hit-test' ] });
    let hitTestSourceRequested = false;
    let hitTestSource: null | XRHitTestSource = null;
    let controller: Object3D;
    const reticle = new v3d.Mesh(
        new v3d.RingGeometry(0.15, 0.2, 32).rotateX(- Math.PI / 2),
        new v3d.MeshBasicMaterial({
            color: new v3d.Color('#5b6ecf'),
            side: v3d.DoubleSide,
        }),
    );
    reticle.position.x = -0.1;
    reticle.matrixAutoUpdate = false;
    reticle.visible = false;
    app.scene.add(reticle);
    const onSelect = () => {
        if (reticle.visible) {
            const toolChest = $.toolChest?.model;
            if (toolChest) {
                if (!toolChest.parent)
                    app.scene.add(toolChest);
                reticle.matrix.decompose(toolChest.position, toolChest.quaternion, toolChest.scale);
            }
        } else {
            alert('not visible');
        }
    };

    $.ARButton.addEventListener('click', ()=>{
        app.controls.enabled = false;
        const model = $.toolChest?.model;
        model?.removeFromParent();
        app.renderer.setClearColor(0x000000, 0);
        app.scene.background = null;
        app.renderer.xr.enabled = true;
        app.enableRendering();
        controller = app.renderer.xr.getController(0);
        controller.addEventListener('select', onSelect);
        app.scene.add(controller);

    app.renderer.setAnimationLoop((time, frame)=>{

        if (!app.renderer.xr.isPresenting) return;

        const referenceSpace = app.renderer.xr.getReferenceSpace();
        const session: XRSession | null = app.renderer.xr.getSession();

        if (hitTestSourceRequested === false) {
            session?.requestReferenceSpace('viewer').then(function(referenceSpace) {
                session.requestHitTestSource({ space: referenceSpace }).then(function(source) {
                    hitTestSource = source;
                });

            });

            session?.addEventListener('end',  () => {
                window.location.reload();
            });
            hitTestSourceRequested = true;
        }

        if (hitTestSource && referenceSpace) {
            const hitTestResults = frame.getHitTestResults(hitTestSource);
            if (hitTestResults.length) {
                const hit = hitTestResults[ 0 ];
                reticle.visible = true;
                const referenceSpacePose = hit.getPose(referenceSpace);
                if (referenceSpacePose)
                    reticle.matrix.fromArray(referenceSpacePose.transform.matrix);
            } else {
                reticle.visible = false;
            }
        }
        // app.controls.update();
        app.renderer.render(app.scene, app.camera);

        });

    });

    // _________________

    $.render();
};

export async function storeConfigurationUpdate(state: iStoreCaseConfiguration) {
    updateUrlOnStoreChange(state);
    await onStoreUpdateHandler();
}

export const offVisibleScene = ()  => {
    $.app.scene.traverse(child => {
        child.visible = false;
    });
};

export const visibleOffForModel = (model?: Object3D|Group|null) => {
    model?.traverse((child)=>{
        child.visible = false;
    });
};

export const visibleOnForModel = (model: Object3D|Group|null) => {
    model?.traverse((child)=> {
        if (child.name.includes('partition')) return;
        child.visible = true;
    });
};
export const clearFromParent = () => {
    //удаление шкафа и комплектующих
    $.toolChest?.destroy();
    // $.toolChest?.parts.forEach(x => {
    //     x.destroy();
    // });
    delete $.toolChest;
    $.toolChest = null;
    $.render();
};

export const updateOrbitTarget = () => {
    if (!$.toolChest) return;
    //orbitTarget - точка куда смотрит камера
    $.app.getCamera().controls.orbitTarget.position.set(0, 0.95, 0.22);
    if ($.toolChest.blenderName === 'tc_1095' || $.toolChest.blenderName === 'hard_1000') {
        $.app.getCamera().controls.orbitTarget.position.y = 0.475;
    }
    if ($.toolChest.blenderName === 'tc_1947') {
        $.app.getCamera().controls.orbitTarget.position.x = 0.235;
    }
};

export const getModel = (name: string) => {
    if (!$.app) console.error('$.app не инизиализировалось');
    return $.app.scene.getObjectByName(name);
};

